export function isActiveLicense(license: { expires_at?: string }): boolean {
  return !license.expires_at || new Date(license.expires_at) > new Date();
}
